import { classes } from 'html-classes';
import { observer } from 'mobx-react-lite';
import { useTranslation } from 'react-i18next';
import Skeleton from 'react-loading-skeleton';

import { company } from '~/company/Company';
import ProductCard from '~/components/ProductCard/ProductCard';
import ProductCardSkeletonM from '~/components/ProductCardV3/skeletons/ProductCardSkeletonM';
import { ProductListAnalyticsProvider } from '~/components/ProductListAnalytics';
import { useGlobal } from '~/hooks/useGlobal';
import { recommendationsProductList } from '~/services/analytics/productLists';
import { catalogStore } from '~/stores';

import { CarouselView } from './components/CarouselView';
import type { ProductRecommendationsProps } from './interfaces';
import styles from './ProductRecommendations.module.scss';

const ProductRecommendations = ({
  source,
  title,
  className,
  isLoading,
}: ProductRecommendationsProps) => {
  const { isMobile } = useGlobal();
  const { t } = useTranslation();

  const products = catalogStore.productRecommendations[source];

  if (catalogStore.productRecommendationsMeta.isLoading || isLoading) {
    return (
      <div className={classes([styles.root, className])}>
        {title && (
          <h2 className={styles.title}>
            <Skeleton className={styles.titleSkeleton} />
          </h2>
        )}
        <div className={styles.grid}>
          {Array.from({ length: 5 }, (_, i) => (
            <ProductCardSkeletonM
              className={styles.product}
              key={`skeleton-${i}`}
            />
          ))}
        </div>
      </div>
    );
  }
  if (!products || !products.data.length) {
    return null;
  }

  const items = products.data.map((product, index) => (
    <ProductCard
      key={product.id}
      product={product}
      index={index}
      className={styles.product}
    />
  ));
  return (
    <ProductListAnalyticsProvider
      list={recommendationsProductList(source, title ? t(title) : source)}
    >
      <div className={classes([styles.root, className])}>
        {title && <h2 className={styles.title}>{t(title)}</h2>}

        {isMobile ? (
          <div className={styles.grid}>{items}</div>
        ) : (
          <CarouselView>{items}</CarouselView>
        )}
      </div>
    </ProductListAnalyticsProvider>
  );
};

export default observer(ProductRecommendations);
